import React from 'react';
import { AdminSystemPermissions } from '@wajeez-web/core/types';
import { Modal } from '@wajeez-web/components/ui';
import { WajeezList, WajeezRow } from '@wajeez-web/components/list-builder';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { TextInput, Button } from '@wajeez-web/components/ui';
import { PlusCircleIcon } from '@heroicons/react/solid';
import {
  useProductSelector,
  FAQsActions,
  useProductDispatch,
} from '@wajeez-web/stores/product';
interface FAQsCategoriesModalProps extends CommonModalProps<unknown> {
  getData: () => void;
}
const FAQsCategoriesModal: React.FC<FAQsCategoriesModalProps> = ({
  isOpen,
  onClose,
  getData,
}) => {
  const { categoriesStatus, faqsCategoriesData } = useProductSelector(
    (s) => s.faqs
  );
  const [newCategory, setNewCategory] = React.useState('');
  const dispatch = useProductDispatch();
  return (
    <Modal
      title={'FAQs Categories'}
      open={isOpen}
      onClose={onClose}
      withScroll={true}
    >
      <div className="overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400 ">
        <TextInput
          label={'New Category'}
          name="newCategory"
          value={newCategory}
          onChange={(_, val) => setNewCategory(val)}
          suffix={
            <Button
              type="text"
              color="primary"
              Icon={PlusCircleIcon}
              onClick={async () => {
                const res = await dispatch(
                  FAQsActions.createNewCategoryAsync({
                    name: newCategory,
                    languageId: 1,
                  })
                );
                if (res.meta.requestStatus === 'fulfilled') {
                  setNewCategory('');
                  getData();
                }
              }}
            />
          }
        />
        <div className="overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-400 ">
          <WajeezList
            containerType="rows"
            isLoading={categoriesStatus === 'loading'}
            data={faqsCategoriesData}
            keyExtractor={(item) => item.id?.toString() || ''}
            renderItem={(item) => (
              <WajeezRow
                key={item.id}
                title={item.name}
                headerActions={[
                  {
                    label: 'delete',
                    onClick: async () => {
                      const res = await dispatch(
                        FAQsActions.deleteCategoryAsync(item?.id || 0)
                      );
                      if (res.meta.requestStatus === 'fulfilled') {
                        getData();
                      }
                    },
                    // permission: AdminSystemPermissions.faqs.delete,
                    type: 'action',
                  },
                ]}
              />
            )}
          />
        </div>
      </div>
    </Modal>
  );
};

export default FAQsCategoriesModal;
